// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import kanban from '@src/views/apps/kanban/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import categories from '@src/views/products/category/store'
import brands from '@src/views/products/brand/store'
import products from '@src/views/products/store'
import countries from '@src/views/location/Country/store'
import states from '@src/views/location/State/store'
import cities from '@src/views/location/City/store'
import subscription from '@src/views/Subscriptions/store'
import UsersWithSubscription from '@src/views/apps/UsersWithSubscription/store'
import FlashSales from '@src/views/Reports/FlashSales/store'
import AdvertisementSubscriptions from '@src/views/AdvertisementSubsctiptions/store'
import Tickets from '@src/views/UserTickets/store'
import promotions from '@src/views/Reports/Advertisements/store'
import Leads from '@src/views/Reports/Leads/store'
import SalesUsers from '@src/views/Reports/SalesUsers/store'
import UserRequirements from '@src/views/apps/UserRequirements/store'
import Blogs from '@src/views/Blogs/store'
import BlogVideo from '@src/views/BlogVideo/store'
import ReelVideo from '@src/views/ReelVideo/store'
import Opportunity from '@src/views/Opportunity/store'
import Requirement from '@src/views/Requirement/store'
import Seo from '@src/views/seo/store'
import topup from '@src/views/Topup/store'
import newsLetter from '@src/views/products/newsLetter/store'
import homepageBanners from '@src/views/homepageBanners/store'
import homepageBannersimges from '@src/views/homepageBannersimges/store'
import quickenqury from '@src/views/apps/Quick reviews/store'
import VerifiedUser from '@src/views/apps/VerifiedUser/store'
import advertisementbanners from '@src/views/advertisementbanners/store'
import navBars from '@src/views/WebCommon/NavBar/store'
import contactUs from '@src/views/WebCommon/ContactUs/store'
import customerReview from '@src/views/WebCommon/CustomerReview/store'
import socialMedia from '@src/views/WebCommon/SocialMedia/store'
import whyChooseUs from '@src/views/WebCommon/WhyChooseUs/store'
import websiteIcon from '@src/views/WebCommon/WebsiteIcon/store'
import about from '@src/views/WebCommon/About/store'
import terms from '@src/views/WebCommon/Terms/store'
import privacy from '@src/views/WebCommon/Privacy/store'
import attribute from '@src/views/products/store/varientIndex'
import discount from '@src/views/products/discount/store'
import newArrival from '@src/views/products/newArrival/store'
import flashSales from '@src/views/products/flashSales/store'
import productRating from '@src/views/products/webrating/store'
import coupon from '@src/views/WebV2/Coupons/store'
import adSection from '@src/views/WebV2/AdSection/store'

const rootReducer = {
  auth,
  categories,
  brands,
  countries,
  states,
  cities,
  products,
  subscription,
  todo,
  chat,
  email,
  users,
  kanban,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  UsersWithSubscription,
  FlashSales,
  AdvertisementSubscriptions,
  Tickets,
  promotions,
  UserRequirements,
  Leads,
  Blogs,
  BlogVideo,
  ReelVideo,
  Opportunity,
  Requirement,
  topup,
  newsLetter,
  SalesUsers,
  homepageBanners,
  Seo,
  quickenqury,
  homepageBannersimges,
  VerifiedUser,
  advertisementbanners,
  navBars,
  contactUs,
  customerReview,
  socialMedia,
  whyChooseUs,
  websiteIcon,
  about,
  terms,
  privacy,
  attribute,
  webDiscount: discount,
  webNewArrival: newArrival,
  webFlashSales: flashSales,
  webRating: productRating,
  coupon,
  adSection
}

export default rootReducer
